import React, { Component } from "react";
import "./App.css";
import Header from "./components/header";
import NavigationPane from "./components/navigationPane";
import Media from "react-media";
import Block from "./components/block";
import ReactObserver from "react-event-observer";
import GettingStarted from "./components/gettingStarted";
import ExtensionManifest from "./components/extensionManifest";
import ExtensionVersions from "./components/extensionVersions";
import ExtensionContext from "./components/extensionContext";
import ExtensionLocations from "./components/extensionLocations";
import ExtensionPermissions from "./components/extensionPermissions";
import Interactions from "./components/interactions";
import ExceptionHandling from "./components/exceptionHandling";
import ExtensionHeaders from "./components/extensionHeaders";
import Troubleshooting from "./components/troubleshooting";
import Community from "./components/community";

class App extends Component {
  constructor(props) {
    super(props);
    this.observer = ReactObserver();
  }

  state = {
    blocks: undefined,
    selected: 1
  };
  render() {
    return (
      <div className="App">
        <Header />

        <Media query="(min-device-width: 1224px)">
          <div className="content content-wide">
            <NavigationPane
              observer={this.observer}
              items={this.state.blocks}
              selected={this.state.selected}
              onSelectedItem={this.changeSelectedItem}
            />
            <article className="content-child">
              <div className="container container-wide">
                {this.state.blocks &&
                  this.state.blocks.map(block => (
                    <Block
                      key={block.id}
                      item={block}
                      observer={this.observer}
                      content={block.content}
                    />
                  ))}
              </div>
            </article>
          </div>
        </Media>

        <Media query="(max-device-width: 1224px)">
          <div>
            <div className="current-section mobile">
              {this.state.blocks &&
                this.state.blocks[this.state.selected - 1].title}
            </div>
            <div className="content content-mobile">
              <article className="content-child">
                <div className="container">
                  {this.state.blocks &&
                    this.state.blocks.map(block => (
                      <Block
                        key={block.id}
                        item={block}
                        observer={this.observer}
                        content={block.content}
                      />
                    ))}
                </div>
              </article>
            </div>
          </div>
        </Media>
      </div>
    );
  }

  handleScroll = () => {
    var sections = document.getElementsByTagName("h3");
    for (let i = 0; i < sections.length; i++) {
      let topX = sections[i].getBoundingClientRect().top;
      let comparedValue =
        i === sections.length - 1 ? window.innerHeight : window.innerHeight / 2;
      if (topX > 0 && topX < comparedValue) {
        //console.log("selected", i + 1);
        this.setState({ selected: i + 1 });
        return;
      }
    }
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);

    const blocks = [
      { id: 1, title: "Getting Started", content: <GettingStarted /> },
      {
        id: 2,
        title: "Extension Versions",
        content: <ExtensionVersions />
      },
      { id: 3, title: "Extension Manifest", content: <ExtensionManifest /> },
      //{ id: 4, title: "UI Elements", content: <ExtensionVersions /> },
      { id: 4, title: "Extension Context", content: <ExtensionContext /> },
      { id: 5, title: "Extension Locations", content: <ExtensionLocations /> },
      {
        id: 6,
        title: "Extension Permissions",
        content: <ExtensionPermissions />
      },
      {
        id: 7,
        title: "SmartConsole Interactions",
        content: <Interactions />
      },
      { id: 8, title: "Exception Handling", content: <ExceptionHandling /> },
      { id: 9, title: "Extension Headers", content: <ExtensionHeaders /> },
      { id: 10, title: "Troubleshooting", content: <Troubleshooting /> },
      { id: 11, title: "Community", content: <Community /> }
    ];

    if (window.location.hash !== "") {
      blocks.forEach(block => {
        const href = decodeURIComponent(window.location.hash.split("#")[1]);
        if (block.title === href) {
          this.setState({ blocks: blocks, selected: block.id });
        }
      });
    } else this.setState({ blocks: blocks, selected: blocks[0].id });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  changeSelectedItem = id => {
    this.setState({ selected: id });
  };
}

export default App;
